import React, { useContext, useState } from 'react'

import { FirebaseContext } from './Firebase'
import 'firebase/auth'
import 'firebase/functions'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'

const ASSOCIATION_PENDING_KEY = 'openRacerAccountAssociationPending'

export default () => {
    const auth = useContext(FirebaseContext)
    const firebase = auth.app
    const [associationError, setAssociationError] = useState(null)

    const redirectAfterSignIn = () => {
        const redirect = new URLSearchParams(window.location.search).get('redirect')
        const destination = redirect && redirect.startsWith('/')
            ? new URL(redirect, window.location.origin)
            : new URL('/profile', window.location.origin)
        window.location.assign(destination.origin === window.location.origin
            ? `${destination.pathname}${destination.search}${destination.hash}`
            : '/profile')
    }

    const publishClosedRacingLines = async () => {
        await firebase.auth().currentUser.getIdToken(true)
        const publish = firebase.functions().httpsCallable('canCreateRacingLine')
        await publish({ operation: 'publishClosedRacingLines', payload: {} })
    }

    const uiConfig = {
        signInFlow: 'popup',
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID,
        ],
        callbacks: {
            signInSuccessWithAuthResult: async () => {
                sessionStorage.setItem(ASSOCIATION_PENDING_KEY, '1')
                try {
                    await publishClosedRacingLines()
                } catch (publishError) {
                    console.error('Closed racing lines remain private until publishing can be retried.', publishError)
                } finally {
                    sessionStorage.removeItem(ASSOCIATION_PENDING_KEY)
                }
                redirectAfterSignIn()
                return false
            },
            signInFailure: async error => {
                if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
                    return Promise.reject(error)
                }

                const anonymousUser = firebase.auth().currentUser
                if (!anonymousUser?.isAnonymous) {
                    throw new Error('Your anonymous racing-line session is no longer available.')
                }

                const anonymousIdToken = await anonymousUser.getIdToken()
                sessionStorage.setItem(ASSOCIATION_PENDING_KEY, '1')
                setAssociationError(null)
                try {
                    await firebase.auth().signInWithCredential(error.credential)
                    await firebase.auth().currentUser.getIdToken(true)
                    const claimAnonymousRacingLines = firebase.functions().httpsCallable('canCreateRacingLine')
                    await claimAnonymousRacingLines({
                        operation: 'claimAnonymousRacingLines',
                        payload: { anonymousIdToken },
                    })
                    sessionStorage.removeItem(ASSOCIATION_PENDING_KEY)

                    redirectAfterSignIn()
                    return Promise.resolve()
                } catch (associationFailure) {
                    sessionStorage.removeItem(ASSOCIATION_PENDING_KEY)
                    setAssociationError('You are signed in, but we could not add your racing lines to this account. Please try again.')
                    throw associationFailure
                }
            },
        },
        autoUpgradeAnonymousUsers: true,
    }

    return (
        <>
            {associationError && (
                <p role="alert" className="mb-4 rounded-xl bg-red-50 p-4 text-sm text-red-800">
                    {associationError}
                </p>
            )}
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
        </>
    )
}
